<script setup lang="ts">
import PrimeButton from 'primevue/button';
import PrimeDialog from 'primevue/dialog';
import { toRefs } from 'vue';

export type Props = {
  cookiePolicyUrl: string;
};

type Emits = {
  cookiesAccepted: [];
};

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
const { cookiePolicyUrl } = toRefs(props);
</script>

<template>
  <PrimeDialog
    :visible="true"
    position="bottomleft"
    :draggable="false"
    :closable="false"
    :close-on-escape="false"
    style="max-width: 20rem"
  >
    <template #header>
      <h3 class="cookie-banner__title">We use cookies 🍪</h3>
    </template>
    <div class="cookie-banner__content">
      <p>
        To ensure optimal performance, <strong>cookies are essential</strong>. Disabling them may
        cause navigation issues across our digital universe.
      </p>
      <p>
        Rest assured, your data is never traded with aliens 👾, and no third-party tracking beacons
        are allowed onboard.
      </p>
    </div>
    <template #footer>
      <div class="cookie-banner__buttons">
        <a :href="cookiePolicyUrl" target="_blank">
          <PrimeButton label="View Cookie Policy" link severity="secondary" />
        </a>
        <PrimeButton label="Let's Go" @click="emit('cookiesAccepted')" />
      </div>
    </template>
  </PrimeDialog>
</template>

<style lang="scss" scoped>
.cookie-banner {
  &__title {
    font-size: 1.1rem;
    font-weight: 700;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    p {
      line-height: 1.4;
    }

    strong {
      font-weight: 600;
    }
  }

  &__buttons {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>
